import gql from 'graphql-tag';

export default gql`
query GetPendingReviews(
        $lang: String!
        ) {
    getPendingReviews(
        lang: $lang
    ) {
      items {
        __typename
        uuids
        app
        user
        name
        image
        langApprovalPending
        rating
        review
      }
    }
}
`;
